import { useEffect, useState } from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { fetchMySites } from '../api/portal';

// What the portal shows for a device, and what the user may do with it. This
// only shapes the UI; the backend (cdk/lambda/appsync/authz.py) enforces access
// on every call.
//
// Most sites are sensing only: measured temperature and heating on/off. The
// temperature forecast, heating schedule and Daikin card appear only where the
// site has them. When nothing is known about the device (the user isn't seeded
// yet, or an older backend), nothing is hidden and the backend decides, so the
// portal looks as it did before access control.
export function permissionsFor(deviceId, { sites, isAdmin }) {
    const site = (sites || []).find(s => (s.device_ids || []).includes(deviceId));
    if (!site) {
        return { known: false, canOperate: true, canEditDevice: isAdmin, hasSolax: true, hasDaikin: true, hasControl: true };
    }
    return {
        known: true,
        site,
        canOperate: isAdmin || site.role === 'operator' || site.role === 'admin',
        canEditDevice: isAdmin,
        hasSolax: !!site.has_solax,
        hasDaikin: !!site.has_daikin,
        hasControl: !!site.has_control,
    };
}

export default function usePermissions() {
    const [sites, setSites] = useState([]);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        fetchAuthSession()
            .then(s => setIsAdmin((s.tokens?.accessToken?.payload?.['cognito:groups'] || []).includes('admins')))
            .catch(() => setIsAdmin(false));
        // An older backend without getMySites just leaves `sites` empty.
        fetchMySites().then(setSites).catch(() => setSites([]));
    }, []);

    return { sites, isAdmin };
}
